import React from 'react'

export default function LoadingScrean() {
  return (
    <>
      <div id='LoadingScrean' style={{ display: "flex" }} className=" bg-light w-100 vh-100 justify-content-center align-items-center">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </>
  );
}
